export default "__VITE_ASSET__Dg5Xe26r__"